import cookieModal from './../components/cookies_panel'

Vue.component("cookie-modal", cookieModal)

if(document.querySelector('#cookie-consent')) {

    new Vue({
      el: '#cookie-consent'
    })

}
